import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { assign, isEmpty, isObject, last, lowerCase, startCase, transform, upperFirst } from "lodash";
export const HEADER = "!HEADER";
export const EMPTY_JOB = "!EMPTY_JOB";
export const NEW_JOB = "!NEW_JOB";
export const validKeys = ["t4", "pay-stub", "employment-letter", "mls-listing"];
export const flattenObject = (obj, parentKey = "") => {
  return transform(obj, (result, value, key) => {
    const newKey = parentKey ? `${parentKey}.${key}` : key;
    if (isObject(value) && key !== "sin") {
      result[newKey] = HEADER;
      assign(result, flattenObject(value, newKey));
    } else {
      result[newKey] = value;
    }
  }, {});
};
export const payPeriods = {
  annual: 1,
  "semi-annual": 2,
  quarterly: 4,
  monthly: 12,
  "semi-monthly": 24,
  "bi-weekly": 26,
  weekly: 52
};
export const titleCaseKey = key => {
  var _last;
  return startCase((_last = last(key.split("."))) != null ? _last : "");
};
export const sentenceCase = str => upperFirst(lowerCase(str));
export const fullName = pd => {
  var _pd$firstName, _pd$middleName, _pd$lastName;
  return `${(_pd$firstName = pd["first-name"]) != null ? _pd$firstName : ""} ${(_pd$middleName = pd["middle-name"]) != null ? _pd$middleName : ""} ${(_pd$lastName = pd["last-name"]) != null ? _pd$lastName : ""}`.replace(/\s+/g, " ");
};
export const findLabel = (options, desiredValue) => {
  var _options$find$label, _options$find;
  return (_options$find$label = (_options$find = _findInstanceProperty(options).call(options, ({
    value
  }) => value === desiredValue)) == null ? void 0 : _options$find["label"]) != null ? _options$find$label : desiredValue;
};
export const failover = (main, backup) => isEmpty(main) ? backup : main;
export const getLastPartOfKey = key => {
  var _last2;
  return (_last2 = last(key.split("."))) != null ? _last2 : "";
};